import { dsl } from '@wix/yoshi-serverless/wrap';

export const getPost = dsl({
          functionName: 'getPost',
          fileName: 'api/posts/get-post.api',
        });